import React from 'react'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const formatValue = (value) => {
  if (!value) return '-'
  return String(value).replace(/_/g, ' ')
}

const RoleDetailsModal = ({ isOpen, role, onClose, onEdit }) => {
  if (!isOpen || !role) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white overflow-hidden dark:bg-dark rounded-lg shadow-lg w-full md:max-w-3xl relative max-h-[90vh] flex flex-col">
        <div className="flex flex-row justify-between items-center border-b border-gray-200 p-4 flex-shrink-0 dark:border-border-dark">
          <h2 className="text-xl font-bold dark:text-white">Permission Role Details</h2>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
          >
            <IoIosCloseCircleOutline className="h-5 w-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-5">
          <div className="space-y-2">
            <h3 className="text-base font-semibold dark:text-white">{role.name}</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">{role.description || 'No description'}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div className="bg-gray-50 dark:bg-secondaryDark rounded-md p-3">
              <p className="text-gray-500 dark:text-gray-400">Status</p>
              <p className="font-medium dark:text-white">{role.is_active ? 'Active' : 'Inactive'}</p>
            </div>
            <div className="bg-gray-50 dark:bg-secondaryDark rounded-md p-3">
              <p className="text-gray-500 dark:text-gray-400">Total Permissions</p>
              <p className="font-medium dark:text-white">{Array.isArray(role.permissions) ? role.permissions.length : 0}</p>
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm font-medium dark:text-white">Assigned Permissions</p>
            {Array.isArray(role.permissions) && role.permissions.length > 0 ? (
              <div className="space-y-2">
                {role.permissions.map((permission) => (
                  <div
                    key={permission.id}
                    className="border border-gray-200 dark:border-border-dark rounded-md px-3 py-2"
                  >
                    <p className="text-sm font-medium dark:text-white">{permission.name}</p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      Module: {formatValue(permission.module)} | Action: {formatValue(permission.action)}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-500 dark:text-gray-400">No permissions assigned.</p>
            )}
          </div>
        </div>

        <div className="border-t p-4 border-gray-200 flex flex-row items-end justify-end w-full bg-white dark:bg-dark flex-shrink-0 dark:border-border-dark">
          <div className="flex flex-row items-end justify-end gap-4">
            <button
              onClick={onClose}
              className="px-6 text-sm py-2 bg-white dark:bg-dark border dark:border-border-dark dark:text-white text-black rounded-lg"
            >
              Close
            </button>
            <button
              onClick={onEdit}
              className="px-6 text-sm py-2 bg-yellowcolor text-black rounded-lg"
            >
              Edit Role
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoleDetailsModal
